import { getEnvironment } from "@sunrun/sales-experience-shared";
import mixpanel from "mixpanel-browser";

const initMixpanelTracker = () => {
  mixpanel.init(
    getEnvironment() === "production"
      ? "73d911fcd247037193404ee54ca34050"
      : "86a764ad97c52ad199cc8ed33854fe82",
    { persistence: "localStorage" }
  );
};

const Mixpanel = {
  identify: (id: any) => {
    mixpanel.identify(id);
  },
  get_distinct_id: () => {
    return mixpanel.get_distinct_id();
  },
  alias: (id: any) => {
    mixpanel.alias(id);
  },
  track: (name: string, props: any) => {
    mixpanel.track(name, {
      ...props,
      platform: (window as any).ReactNativeWebView ? "mobileWeb" : "web",
    });
  },
  people: {
    set: (props: any) => {
      mixpanel.people.set(props);
    },
  },
  reset: () => {
    mixpanel.reset();
  },
};

export { initMixpanelTracker, Mixpanel };
